exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Windowed Modal Overrides */\n\n.windowed-modal_windowed-modal-content_1UGwp {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    overscroll-behavior: contain;\n}\n\n\n", ""]);

// exports
exports.locals = {
	"windowed-modal-content": "windowed-modal_windowed-modal-content_1UGwp",
	"windowedModalContent": "windowed-modal_windowed-modal-content_1UGwp"
};